var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDragIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.5C5.05228 3.5 5.5 3.05228 5.5 2.5C5.5 1.94772 5.05228 1.5 4.5 1.5C3.94772 1.5 3.5 1.94772 3.5 2.5C3.5 3.05228 3.94772 3.5 4.5 3.5Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5C8.05228 3.5 8.5 3.05228 8.5 2.5C8.5 1.94772 8.05228 1.5 7.5 1.5C6.94772 1.5 6.5 1.94772 6.5 2.5C6.5 3.05228 6.94772 3.5 7.5 3.5Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6C5.5 6.55228 5.05228 7 4.5 7C3.94772 7 3.5 6.55228 3.5 6C3.5 5.44772 3.94772 5 4.5 5C5.05228 5 5.5 5.44772 5.5 6Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7C8.05228 7 8.5 6.55228 8.5 6C8.5 5.44772 8.05228 5 7.5 5C6.94772 5 6.5 5.44772 6.5 6C6.5 6.55228 6.94772 7 7.5 7Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.5C5.5 10.0523 5.05228 10.5 4.5 10.5C3.94772 10.5 3.5 10.0523 3.5 9.5C3.5 8.94772 3.94772 8.5 4.5 8.5C5.05228 8.5 5.5 8.94772 5.5 9.5Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5C8.05228 10.5 8.5 10.0523 8.5 9.5C8.5 8.94772 8.05228 8.5 7.5 8.5C6.94772 8.5 6.5 8.94772 6.5 9.5C6.5 10.0523 6.94772 10.5 7.5 10.5Z",
    fill: "#625E70"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDragIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drag-icon.02f80565cb63ba84404dd2970688f426.svg";